import { useTranslation } from 'react-i18next';
import { FormField } from '@noor/ui';

/**
 * The product's VAT rate. Left empty it is not sent and the product takes the
 * brand's rate; `0` is an explicit "no VAT" — so the placeholder says what an
 * empty box means rather than showing a number.
 */
export function VatPercentField({
  className,
  fieldClassName,
}: {
  className?: string;
  fieldClassName?: string;
}) {
  const { t } = useTranslation('eats');
  return (
    <FormField name="vatPercent" {...(className ? { className } : {})}>
      <FormField.Label className="flex items-center gap-0.5 text-sm font-medium tracking-tight">
        {t('menu.product.form.vatPercentLabel')}
      </FormField.Label>
      <FormField.Number
        {...(fieldClassName ? { className: fieldClassName } : {})}
        min={0}
        max={100}
        decimals={2}
        suffix="%"
        placeholder={t('menu.product.form.vatPercentPlaceholder')}
      />
      <span className="text-xs leading-relaxed text-muted-foreground">
        {t('menu.product.form.vatPercentHint')}
      </span>
      <FormField.Message />
    </FormField>
  );
}
